import React from 'react';
import styled from 'styled-components';
import { Grid, GridColumn } from 'components/page';
import { gridSize } from 'components/theme';

const Padding = styled.div`
  // margin: ${gridSize() * 2}px ${gridSize() * 0}px;
  padding-top: ${gridSize() * 2}px;
  padding-bottom: ${gridSize() * 4}px;
`;

const ContentWrapper = ({ children }) => (
  <Padding>
    <Grid layout="fluid" spacing="comfortable">
      <GridColumn> {children}</GridColumn>
    </Grid>
  </Padding>
);

// {/*<GridColumn>*/}
// {/*  <Padding>{children}</Padding>*/}
// {/*</GridColumn>*/}

export default ContentWrapper;
